import { render } from "./Payroll.vue?vue&type=template&id=62c466f5"
import script from "./Payroll.vue?vue&type=script&lang=js"
export * from "./Payroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__